import Parse from "parse";

Parse.initialize("opendashfit");
Parse.serverURL = "https://ad4gd.fit.fraunhofer.de/parse";
